// src/firebase/keyringService.js
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase";

const KEYRINGS = "keyrings";

export const getKeyring = async (uid) => {
  const snap = await getDoc(doc(db, KEYRINGS, uid));
  return snap.exists() ? snap.data() : null;
};

// Call only when getKeyring === null (first setup) or after passphrase change.
export const saveKeyring = async (uid, keyring) => {
  await setDoc(doc(db, KEYRINGS, uid), { ...keyring, updatedAt: new Date() });
};
